<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-6 col-sm-6 col-xs-12">
                <img src="../../assets/SmartWaterLogo.gif" class="img-responsive" style="width:100%">
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <img src="../../assets/WDBC-Logo-718x609.png" class="img-responsive" style="width:100%">
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>
